import { render } from "./LoadingItems.vue?vue&type=template&id=4bb39583&scoped=true"
import script from "./LoadingItems.vue?vue&type=script&lang=js"
export * from "./LoadingItems.vue?vue&type=script&lang=js"

import "./LoadingItems.vue?vue&type=style&index=0&id=4bb39583&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb39583"]])

export default __exports__